// app/javascript/services/media_storage_service.js
import { openDB } from 'idb'

export default class MediaStorageService {
  constructor() {
    this.dbName = 'media'
    this.storeName = 'media'
    this.version = 1
    this.db = null
  }

  async initDB() {
    if (this.db) return this.db

    this.db = await openDB(this.dbName, this.version, {
      upgrade(db) {
        if (!db.objectStoreNames.contains('media')) {
          db.createObjectStore('media', { keyPath: 'id', autoIncrement: true })
        }
      }
    })

    return this.db
  }

  async saveMedia(groupId, blob, type) {
    const db = await this.initDB()
    
    return await db.add(this.storeName, {
      groupId,  // Using roadId instead of patrolId
      blob,
      type,
      timestamp: new Date().toISOString()
    })
  }

  async getMediaByGroupId(groupId) {  // Changed method name to reflect roadId usage
    const db = await this.initDB()
    const allMedia = await db.getAll(this.storeName)
    
    return allMedia.filter(media => media.groupId == groupId)
  }

  async clearPatrolMedia(groupId) {  // Still named clearPatrolMedia but uses roadId
    const db = await this.initDB()
    const tx = db.transaction(this.storeName, 'readwrite')
    const store = tx.objectStore(this.storeName)
    
    // Get all keys first
    const allMedia = await store.getAll()
    const keysToDelete = allMedia
      .filter(media => media.groupId == groupId)
      .map(media => media.id)
    
    // Delete all matching items
    await Promise.all(keysToDelete.map(key => store.delete(key)))
    
    await tx.done
  }

  async getMediaForGroup(groupId) {
    const db = await this.initDB()
    try {
      const tx = db.transaction('media', 'readonly')
      const store = tx.objectStore('media')
      
      // Get all media entries and filter by road_id
      const allMedia = await store.getAll()
      console.log(allMedia)
      return allMedia.filter(media => media.groupId == groupId)
        .map(media => ({
          groupId: media.groupId,
          blob: media.blob,
          type: media.type,
          timestamp: media.timestamp
        }))
    } finally {
      db.close()
    }
  }
}
